import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/Home';
import SignIn from './components/Register/Login';
import SignUp from './components/Register/SignUp';
import Dashboard from './components/Profile/dashboard';
import YourProduct from './components/Profile/Products';
import OrderHistory from './components/Profile/orderHistory';
import Cart from './components/Profile/Carts';
import Store from './components/Store';
import AddedProduct from './components/Profile/Products/addedPrd';
import ChatGroups from './components/Chat/chatGroup';
import ChatRoom from './components/Chat/chatRoom';
import BuyProduct from './components/Store/buyProduct';
import TrackProduct from './components/Store/trackProduct';
import Payment from './components/Store/payment';
import Teach from './components/Teach';

const CompRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage/>} />

        {/* Profile */}
        <Route path="/profile" element={<HomePage/>} />
        <Route path="/profile/:userId/dashboard" element={<Dashboard/>} />
        <Route path="/profile/:userId/orderHistory" element={<HomePage/>} />

        {/* Register */}
        <Route path="/signup" element={<SignUp/>} />
        <Route path="/login" element={<SignIn/>} />
        
        {/* Store */}
        <Route path="/store/:userId" element={<Store/>} />
        <Route path="/store/:userId/:prodId" element={<BuyProduct/>} />
        <Route path="/store/:userId/:prodId/track" element={<TrackProduct/>} />
        <Route path="/store/:userId/:prodId/payment" element={<Payment/>} />


        {/* Profile Store */}
        <Route path="/profile/:userId/cart" element={<Cart/>} />
        <Route path="/profile/:userId/product" element={<YourProduct/>} />
        <Route path="/profile/:userId/added-prd" element={<AddedProduct/>} />
        <Route path="/profile/:userId/orderHistory" element={<OrderHistory/>} />
      
      {/* Chat */}
        <Route path="/chat/:userId" element={<ChatGroups/>} />
        <Route path="/chat/:userId/:groupId" element={<ChatRoom/>} />

      {/* Teach */}
        <Route path="/teach" element={<Teach/>} />

      </Routes>
    </Router>
  );  
};

export default CompRoutes;